import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';

import { useStore } from '../../../../hooks';

import './slotHistory.scss'

export const SlotHistoryFrame: React.FC = observer(() => {
  const { slotHistoryStore, userActivityStore, gameStore, postMessageStore } = useStore();
  const { launchData: { data: launchData } } = gameStore;

  useEffect(() => {
    if (slotHistoryStore.refTokenInfo && launchData) {
      slotHistoryStore.openSlotsHistory(launchData);
    }
  }, [slotHistoryStore.refTokenInfo, launchData]);

  const refCallback = useCallback((element: HTMLIFrameElement | null) => {
    if (element) {
      postMessageStore.setSlotHistoryIframeElement(element);
      userActivityStore.attachEventListeners(element?.contentWindow);
    }
  }, []);

  if (!slotHistoryStore.historyUrl) return null;

  return (
    <iframe
      ref={refCallback}
      title="slot-history"
      src={slotHistoryStore.historyUrl}
      className="slot-history-frame"
      sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-forms allow-scripts"
      allow="fullscreen; clipboard-read; clipboard-write"
    />
  );
});
